import {SchoolAcademicYearTableColumn} from '../../../components/academic-year-search-form';
import {
    AcademicYearCell, ChangeCell, YearNameCell
} from '../../../components/academic-year-search-form/components';

export const createColumns = (): Array<SchoolAcademicYearTableColumn> => [
    {
        Header: 'C3 ID',
        accessor: 'crmId',
        disableFilters: true
    },
    {
        Header: 'School name',
        accessor: 'name',
        defaultCanSort: true,
        disableFilters: true
    },
    {
        Header: 'Region',
        accessor: (record) => {
            return record.region?.name;
        },
        defaultCanSort: true,
        disableFilters: true
    },
    {
        Header: 'Country-City',
        disableFilters: true,
        accessor: (record) => {
            const country = record.country || '';
            const city = record.city || '';
            const separator = record.country && record.city ? ', ' : '';
            return [country, city].join(separator);
        }
    },
    {
        Header: 'School Admin',
        accessor: 'schoolAdmin',
        disableFilters: true
    },
    {
        Header: 'Type',
        accessor: (record) => {
            return record.academicYear?.isSchoolAcademicYear ? 'School' : 'Region';
        },
        defaultCanSort: true,
        disableFilters: true
    },
    {
        Header: 'Academic Year',
        Cell: AcademicYearCell,
        disableFilters: true
    },
    {
        Header: 'Year name',
        Cell: YearNameCell,
        disableFilters: true
    },
    {
        Header: 'Change',
        Cell: ChangeCell,
        disableFilters: true
    }
];
